import { render, staticRenderFns } from "./KeyWords.vue?vue&type=template&id=1f5ccff0&"
import script from "./KeyWords.vue?vue&type=script&lang=js&"
export * from "./KeyWords.vue?vue&type=script&lang=js&"
import style0 from "./KeyWords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports